export default __webpack_public_path__ + "static/BZ_COBERTURADC_EP_R00-1_Pgina_33-d8f3d480f5b78fa369a0a2b31cc64015.jpg";